export const teacherMessages = {
    birthDate: 'Date of birth',
    branchOfService: 'Branch of service',
    changeLanguage: 'Change language',
    country: 'Country',
    emailExplanation: 'School-issued email required',
    schoolName: 'School name',
    schoolNamePlaceholder : 'School name',
    dateTime: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
        month: 'Month',
        day: 'Day',
        year: 'Year',
        '20_MIN': '20 minutes',
        '2_HOURS': '2 hours',
        '24_HOURS': '24 hours',
        '3_DAY': '3 days',
        A_FEW_MINUTES: 'a few minutes',
        A_FEW_HOURS: 'a few hours',
        A_FEW_DAYS: 'a few days',
    },
    dischargeDate: 'Discharge date',
    emailAddress: 'Email address (School-issued email required)',
    error: 'Error',
    alreadyRedeemedError: 'Already Redeemed',
    firstName: 'First name',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.',
    lastName: 'Last name',
    loading: 'Loading...',
    locales: {
        'en-US': 'English',
        fr: 'French',
    },
    militaryStatus: 'Military status',
    noOptions: 'No options',
    personalInformation: 'Personal Information',
    personalOrSchoolIsFine: 'Personal or school email is fine',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    requiredFields: 'All fields are required',
    school: 'School',
    sheeridFaqs: 'SheerID FAQs',
    studentInfoShared: 'Information entered into this web form will be used for verification purposes. The information will be shared with Cheap Caribbean. ',
    universityName: 'University name',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: 'Used for verification purposes only',
    verifyMyStudentStatus: 'Verify My Student Status',
    verifyMyTeacherStatus: 'VERIFY MY TEACHER STATUS',
    verifyMyMilitaryStatus: 'Verify My Military Status',
    verifyMyMedicalProfessionalStatus: 'Verify My Medical Professional Status',
    status: 'Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Military Retiree',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Active Duty',
    MILITARY_FAMILY: 'Registered Military Dependent',
    FIREFIGHTER: 'Firefighter',
    POLICE: 'Police',
    EMT: 'EMT',
    organization: 'Organization',
    verifyMyFirstResponderStatus: 'Verify My First Responder Status',
    firstResponderInfoShared: 'Information entered here will be used for verification purposes',
    militaryInfoShared: 'Information entered here will be used for verification purposes.',
    tryAgain: 'Try again',
    errorId: {
        internalServerError: 'Internal server error',
        noProgram: 'No program found',
        noVerification: 'No verification found',
        expiredProgram: 'This link is no longer active',
        invalidProgram: 'Invalid program',
        invalidStep: 'Invalid step',
        invalidMilitaryStatus: 'Invalid military status',
        invalidFirstResponderStatus: 'Invalid first responder status',
        invalidOrganization: 'You must select an organization from the list',
        invalidFirstName: 'Invalid first name',
        invalidLastName: 'Invalid last name',
        invalidBirthDate: 'Invalid birth date',
        invalidEmail: 'Invalid email',
        invalidPostalCode: 'Invalid postal code',
        underagePerson: 'Persons under age 16 are not eligible for this offer.',
        outsideAgePerson: 'Age outside allowed range',
        futureBirthDate: 'Future birthdate',
        unsupportedDocMimeType: 'One or more files is an unsupported format',
        invalidFileSizeEmpty: 'One or more files is empty',
        invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
        invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
        invalidDocUploadToken: 'Provided document upload token is not valid',
        verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed this offer.',
        docReviewLimitExceeded: 'Document review limit exceeded',
        maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
        maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
        unknownError: 'Unknown Error',
        invalidRequest: 'Invalid request',
        invalidApiToken: 'Provided API token was invalid or empty',
        simulatedError: 'This is a simulated error',
        notFound: 'Not found',
        unauthorizedDomain: 'Unauthorized domain',
    },
    step: {
        personalInfo: {
            title: 'UNLOCK THIS TEACHER-ONLY OFFER',
            subtitle: "Verify you're a teacher at a K-12 school.",
            howDoesVerifyingWorkDetails: `
            To be eligible for this offer, you must currently be employed as a teacher, faculty or staff at a K-12
            school in the United States.
            <br><br>
            Cheap Caribbean uses SheerID, a trusted partner, to verify that you are a current teacher, faculty or staff
            member. SheerID only collects information that assists in verifying your eligibility. Additional information
            or documentation may be requested.`,
            tryAgain: {
                title: 'Check Your Name & Email',
                subtitle: 'Your full name and email address must match what is on record with your school.',
            },
        },
        docUpload: {
            title: 'WE NEED SOME MORE INFO',
            acceptableUploadExamples: 'Acceptable examples include:',
            acceptedTypes: 'File must be .jpg .jpeg .png .pdf .gif or .bmp',
            addFile: 'Add file',
            cancelButtonLabel: 'CANCEL',
            fileInstructions: 'Drag and drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            footer: '',
            submitButtonLabel: 'SUBMIT',
            rejectedSubtitle: 'We were unable to confirm your eligibility due to:',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.
                <br><br>
                Documents are used only for verifying your teacher or faculty status is current and will be permanently
                deleted after review is finalized. They will not be shared with Cheap Caribbean`,
            uploadInstructions: 'Upload your school-issued document that shows:',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that\'s bright and crisp, and try submitting again.',
                DOCUMENT_PASSWORD_PROTECTED: 'We are unable to accept password protected documents.',
                DOCUMENT_LIKELY_FRAUD: 'The document you submitted is insufficient for establishing eligibility for this offer.',
                DOCUMENT_UNSUPPORTED: 'The document you submitted is not on the list of accepted document types.',
                DOCUMENT_HANDWRITTEN: 'We cannot accept handwritten documents.',
                MISSING_INFORMATION: 'The document you submitted does not provide all of the information necessary to determine eligibility for this offer.',
                MISSING_INFORMATION_PERSON_NAME: 'The document you submitted is missing a first and/or last name.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'The document you submitted does not include an organization name that confirms your connection to that organization.',
                DOCUMENT_EXPIRED: 'The document you submitted has expired.',
                DOCUMENT_OUTDATED: 'The document you submitted is missing an issue date or was issued too far in the past.',
                MISMATCH_PERSON_NAME: 'The information on the document you submitted does not match the first and/or last name submitted on the verification form.',
                MISMATCH_ORGANIZATION: 'The organization name on the document(s) you submitted does not match the organization you listed on the verification form.',
                MISMATCH_STATUS: 'The status on the document you submitted does not match the status you listed on your verification form.',
                INELIGIBLE_ORGANIZATION: 'The organization on the document you submitted is not eligible for this offer.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'The document you submitted does not prove enrollment in the current term.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'High School Students are not eligible for this offer.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'The company name or address in your document does not match what you entered on the verification form.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Please upload a paystub that was issued within the last 30 days.',
                MISSING_INFORMATION_BIRTHDATE: 'The document you submitted is missing a birthdate, or your age is ineligible for this offer.',
                MISMATCH_BIRTHDATE: 'The birthdate on the document you submitted does not match the birthdate you listed on the verification form.',
                DOCUMENT_OUTDATED_FACULTY: 'The document you submitted does not prove employment in the current academic year.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'The job title on the document you submitted is missing or does not match what you entered on the verification form.',
                OTHER_CONTACT_US: 'We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'A field in the document provided did not match with what was provided on the verification form.'
            },
            uploadInfo: {
                fullName: 'Your full name',
                student: {
                    enrollmentDate: 'Date proving enrollment for the current term (or within the last 3 months)',
                    school: 'Your school',
                },
                teacher: {
                    currentSchoolYear: 'A date in the current school year',
                    school: 'Your school',
                },
                military: {
                    currentAffiliation: 'Your current affiliation with the armed services',
                    dischargeDate: 'Your discharge date (if applicable)',
                    serviceBranch: 'Your branch of service',
                    uploadInstructionsDependent: 'Please upload a document that clearly shows your first name, last name, valid dates and status',
                },
                senior: {
                    birthDate: 'Your date of birth',
                },
                firstResponder: {
                    currentAffiliation: 'Your current affiliation with that organization',
                    organization: 'Your organization',
                },
                medical: {
                    status: 'Your medical professional status',
                    validDate: 'A currently valid date',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'School ID card with expiration date',
                    classSchedule: 'Class schedule',
                    tuitionReceipt: 'Tuition receipt',
                },
                teacher: {
                    idCard: 'Teacher ID card with valid date',
                    payStub: 'Pay stub from within last 60 days',
                },
                senior: {
                    birthCertificate: 'Your birth certificate',
                    driversLicense: 'Your drivers license',
                    passport: 'Your passport',
                    stateId: 'Your state-issued ID',
                },
                military: {
                    activeDuty: 'Any document that proves you are currently serving under Title 10 Active Duty Orders for 30 days or more',
                    veteran: 'Any document that proves you met the qualifications of military service and were honorably discharged',
                    reservistA: 'Any document that shows you are currently serving in the National Guard or a Reserve Component of The United States Armed Forces',
                    retiree: 'Any document that proves you are a Retiree from the US Armed Forces',
                    dependent: 'Any document that proves you are a Registered Military Dependent',
                },
                medical: {
                    licenseCertificate: 'Certificate of license',
                    idCard: 'Nursing ID card with expiration date',
                    photoPayStub: 'Photo ID and recent Pay Stub',
                },
            },
        },
        pending: {
            title: 'PROCESSING',
            subtitle: 'We are reviewing your documents to confirm your status. <br><br>This process may take up to {maxReviewTime}.',
            subtitle2: 'You can wait here or check your email for details regarding your verification request',
            subtitle3: 'You will be contacted via email.',
            storeButton: 'CONTINUE TO CHEAPCARIBBEAN.COM',
        },
        success: {
            title: "SUCCESS! YOU'VE BEEN VERIFED",
            copyCouponCode: 'Copy promo code',
            redirectButtonText: 'CONTINUE',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from cheapcaribbean@sheerid.com.',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to Cheap Caribbean customer service.
            `,
        },
    },
};
